/** Match current location against a tour step route (path + required query params). */
export function matchesTourRoute(
  required: string | undefined,
  pathname: string,
  search: string,
): boolean {
  if (!required) return true
  const normalizedSearch = search.startsWith('?') ? search : search ? `?${search}` : ''
  const [reqPath, reqQuery = ''] = required.includes('?') ? required.split('?') : [required, '']
  if (reqPath !== pathname) return false
  if (!reqQuery) return true
  const reqParams = new URLSearchParams(reqQuery)
  const curParams = new URLSearchParams(normalizedSearch.replace(/^\?/, ''))
  for (const [key, value] of reqParams.entries()) {
    if (curParams.get(key) !== value) return false
  }
  return true
}

export function buildTourNavigatePath(route: string | undefined): string | null {
  if (!route) return null
  return route.startsWith('/') ? route : `/${route}`
}
